var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.883,
    height: 34,
    viewBox: "0 0 29.883 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(-31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1252",
    "data-name": "Group 1252",
    transform: "translate(34.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1251",
    "data-name": "Group 1251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3499",
    "data-name": "Path 3499",
    d: "M101.957,0a10.952,10.952,0,0,0-8.906,17.332l8.068,12.589a1,1,0,0,0,1.677,0l8.1-12.632A10.957,10.957,0,0,0,101.957,0Zm0,15.938a4.98,4.98,0,1,1,4.98-4.98A4.986,4.986,0,0,1,101.957,15.938Z",
    transform: "translate(-91)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1254",
    "data-name": "Group 1254",
    transform: "translate(31 22.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1253",
    "data-name": "Group 1253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3500",
    "data-name": "Path 3500",
    d: "M53.728,344.7l-5.016,7.842a3.293,3.293,0,0,1-5.544,0L38.145,344.7c-4.42,1.022-7.145,2.894-7.145,5.131,0,3.882,7.7,5.977,14.941,5.977s14.941-2.094,14.941-5.977C60.883,347.59,58.154,345.716,53.728,344.7Z",
    transform: "translate(-31 -344.695)",
    fill: "#7dbaab"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomLocationIcon);
export default __webpack_public_path__ + "static/media/zoom-location-icon.cf23063a245ddadd156e5b4fe5f7cdec.svg";
export { ForwardRef as ReactComponent };